import React from 'react';
import { ViewState } from '../types';

interface HeaderProps {
  currentView: ViewState;
  onNavigate: (view: ViewState) => void;
  unlockedCount: number;
  onOpenUnlocked: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  currentView,
  onNavigate,
  unlockedCount,
  onOpenUnlocked,
}) => {
  return (
    <header className="no-print sticky top-0 z-30 border-b border-[#232736] bg-[#090a0f]/90 backdrop-blur-md">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <div
          className="flex items-center gap-3 cursor-pointer group"
          onClick={() => onNavigate('home')}
        >
          <div className="w-8 h-8 rounded border border-sky-500/40 bg-sky-500/10 flex items-center justify-center text-sky-400 font-mono font-bold text-sm shadow-[0_0_12px_rgba(56,189,248,0.2)] group-hover:border-sky-400 transition">
            RB
          </div>
          <div className="flex flex-col">
            <span className="font-tech text-base tracking-tight font-bold text-white uppercase">
              Runbook<span className="text-sky-400 font-normal">Bureau</span>
            </span>
            <span className="text-[10px] font-mono tracking-widest text-[#8b92a5] uppercase">
              Operating Protocols &amp; Tools · v2.5
            </span>
          </div>
        </div>

        <nav className="flex items-center gap-1 sm:gap-2">
          <button
            onClick={() => onNavigate('tools')}
            className={`px-3 py-1.5 text-xs font-mono rounded border transition flex items-center gap-1.5 ${
              currentView === 'tools'
                ? 'border-sky-500/40 bg-sky-500/10 text-sky-300 font-bold'
                : 'border-transparent text-[#8b92a5] hover:text-white'
            }`}
          >
            <span className="w-1.5 h-1.5 rounded-full bg-sky-400 animate-pulse" />
            MICRO-TOOLS
            <span className="text-[10px] px-1.5 py-0.5 rounded bg-sky-400 text-black font-bold">4</span>
          </button>
          <button
            onClick={() => onNavigate('catalog')}
            className={`px-3 py-1.5 text-xs font-mono rounded border transition ${
              currentView === 'catalog'
                ? 'border-sky-500/40 bg-sky-500/10 text-sky-300'
                : 'border-transparent text-[#8b92a5] hover:text-white'
            }`}
          >
            RUNBOOKS
          </button>
          <button
            onClick={() => onNavigate('compiler')}
            className={`px-3 py-1.5 text-xs font-mono rounded border transition ${
              currentView === 'compiler'
                ? 'border-sky-500/40 bg-sky-500/10 text-sky-300'
                : 'border-transparent text-[#8b92a5] hover:text-white'
            }`}
          >
            COMPILER
          </button>
          <button
            onClick={() => onNavigate('terminal')}
            className={`px-3 py-1.5 text-xs font-mono rounded border transition ${
              currentView === 'terminal'
                ? 'border-sky-500/40 bg-sky-500/10 text-sky-300'
                : 'border-transparent text-[#8b92a5] hover:text-white'
            }`}
          >
            TERMINAL
          </button>

          {unlockedCount > 0 && (
            <button
              onClick={onOpenUnlocked}
              className="ml-2 px-2.5 py-1 bg-emerald-500/10 border border-emerald-500/30 rounded text-[11px] font-mono text-emerald-400 hover:bg-emerald-500/20 transition flex items-center gap-1.5"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
              ACCESS: {unlockedCount}
            </button>
          )}
        </nav>
      </div>
    </header>
  );
};
